import { ReactElement, ReactNode } from 'react';
import { ButtonProps } from 'antd';
import {
  SWrapper,
  SButton,
  SInner,
} from './IconButton.style';

type Props = ButtonProps & {
  children?: ReactNode;
  active?: boolean;
};

export const IconButton = ({ children, icon, active = false, ...restProps }: Props): ReactElement => (
  <SWrapper active={active}>
    <SButton icon={icon} {...restProps}>
      {children && <SInner>{children}</SInner>}
    </SButton>
  </SWrapper>
);
